import React from "react";

export default function Privacy({ t }) {
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      {/* Hero Section για το Privacy */}
      <section style={{ 
        background: "linear-gradient(135deg, var(--electric-blue) 0%, #2563eb 100%)",
        color: "white",
        padding: "4rem 2rem",
        textAlign: "center"
      }}>
        <h1 style={{ 
          fontSize: "2.5rem", 
          marginBottom: "1rem",
          fontWeight: "bold"
        }}>
          {t.privacy_title}
        </h1>
        <p style={{ 
          fontSize: "1.2rem", 
          opacity: 0.9,
          maxWidth: "600px",
          margin: "0 auto"
        }}>
          {t.privacy_intro}
        </p>
      </section>

      {/* Privacy Content */}
      <section style={{ padding: "4rem 2rem" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <div style={{ 
            backgroundColor: "white", 
            padding: "3rem", 
            borderRadius: "12px", 
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            lineHeight: "1.7"
          }}>
            <div style={{ marginBottom: "3rem" }}>
              <h2 style={{ 
                color: "var(--electric-blue)", 
                marginBottom: "1.5rem",
                fontSize: "1.5rem",
                borderBottom: "2px solid var(--electric-blue)",
                paddingBottom: "0.5rem"
              }}>
                {t.privacy_collection_title}
              </h2>
              <p style={{ color: "#555", fontSize: "1.1rem" }}>
                {t.privacy_collection_text}
              </p>
            </div>

            <div style={{ marginBottom: "3rem" }}>
              <h2 style={{ 
                color: "var(--electric-blue)", 
                marginBottom: "1.5rem",
                fontSize: "1.5rem",
                borderBottom: "2px solid var(--electric-blue)",
                paddingBottom: "0.5rem"
              }}>
                {t.privacy_use_title}
              </h2>
              <p style={{ color: "#555", fontSize: "1.1rem" }}>
                {t.privacy_use_text}
              </p>
            </div>

            <div style={{ marginBottom: "3rem" }}>
              <h2 style={{ 
                color: "var(--electric-blue)", 
                marginBottom: "1.5rem",
                fontSize: "1.5rem",
                borderBottom: "2px solid var(--electric-blue)",
                paddingBottom: "0.5rem"
              }}>
                {t.privacy_rights_title}
              </h2>
              <p style={{ color: "#555", fontSize: "1.1rem" }}>
                {t.privacy_rights_text}
              </p>
            </div>

            <div style={{ 
              backgroundColor: "#f8f9fa",
              padding: "2rem",
              borderRadius: "8px",
              borderLeft: "4px solid var(--electric-blue)"
            }}>
              <h2 style={{ 
                color: "var(--electric-blue)", 
                marginBottom: "1rem",
                fontSize: "1.3rem"
              }}>
                {t.privacy_contact_title}
              </h2>
              <p style={{ color: "#555", fontSize: "1.1rem", margin: 0 }}>
                {t.privacy_contact_text}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}